import { Alert, Cell, Grid } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { usePecField } from 'components/form/core/hooks/useField'
import { LotacaoAndEstagioSelectFieldModel } from 'components/form/field/select/LotacaoAndEstagioSelectField/LotacaoAndEstagioSelectField'
import { Fragment, useState } from 'react'
import { isUndefinedOrNull } from 'util/checks'
import { MetaPath } from 'util/metaPath'
import {
  MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_CBO_SEM_PERMISSAO_CIDADAO,
  MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_CBO_SEM_PERMISSAO_IMOVEL,
  MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_SEM_CBO,
  MENSAGEM_RESPONSAVEL_NAO_INFORMADO,
} from 'view/cadastro-imovel/model-cadastroImovel'

import { EditarLotacaoResponsavelModal } from './EditarLotacaoResponsavelModal'
import { LotacaoResponsavelCard } from './LotacaoResponsavelCard'
import { LotacaoResponsavelFormModel } from './model-lotacaoResponsavel'

interface LotacaoResponsavelSectionProps {
  name: MetaPath<LotacaoResponsavelFormModel>
  isCadastroImovel?: boolean
  isCadastroIndividual?: boolean
  isAtividadeColetiva?: boolean
  isLotacaoActive?: boolean
  loadItemsOnOpen?: boolean
  hideProfissionalAndCboInCard?: boolean
  equipeLabel?: string
  equipeFallbackLabel?: string
  alterarResponsavelLabel?: string
  modalTitle?: string
  modalLotacaoLabel?: string
  skipCboValidation?: boolean
  canWriteCadastroIndividual?: boolean
  disableProfissionalFilters?: boolean
  apenasAps?: boolean
}

export function LotacaoResponsavelSection(props: LotacaoResponsavelSectionProps) {
  const {
    name,
    isCadastroImovel,
    isCadastroIndividual,
    isAtividadeColetiva,
    isLotacaoActive,
    loadItemsOnOpen,
    hideProfissionalAndCboInCard,
    equipeLabel,
    equipeFallbackLabel,
    alterarResponsavelLabel,
    modalTitle,
    modalLotacaoLabel,
    skipCboValidation,
    canWriteCadastroIndividual,
    disableProfissionalFilters,
    apenasAps = false,
  } = props
  const acessoLotacaoOrEstagio = useAcessoLotacaoOrEstagio()
  const municipioId = acessoLotacaoOrEstagio?.acesso?.municipio?.id
  const [isModalResponsavelOpen, setIsModalResponsavelOpen] = useState(false)

  const {
    input: {
      value: { lotacao },
      onChange,
    },
  } = usePecField({ name })

  const handleEditarLotacaoResponsavel = (novoResponsavel: LotacaoAndEstagioSelectFieldModel) => {
    onChange({ lotacao: novoResponsavel })
  }

  const shouldDisableProfissionalFilters = !!isCadastroIndividual && !!disableProfissionalFilters
  const errorMessage = getLotacaoErrorMessage(lotacao, isCadastroImovel, isCadastroIndividual, !!skipCboValidation)
  return (
    <Fragment>
      <Grid>
        <Cell size={12}>
          <LotacaoResponsavelCard
            responsavel={lotacao}
            isLotacaoActive={isLotacaoActive}
            hideProfissional={hideProfissionalAndCboInCard}
            hideCbo={hideProfissionalAndCboInCard}
            equipeLabel={equipeLabel}
            equipeFallbackLabel={equipeFallbackLabel}
            alterarResponsavelLabel={alterarResponsavelLabel}
            onAlterarResponsavel={() => setIsModalResponsavelOpen(true)}
          />
        </Cell>
        {(isCadastroImovel || isCadastroIndividual) && errorMessage && (
          <Cell size={12}>
            <Alert type='danger'>{errorMessage}</Alert>
          </Cell>
        )}
      </Grid>

      <EditarLotacaoResponsavelModal
        open={isModalResponsavelOpen}
        municipioId={municipioId}
        onClose={() => setIsModalResponsavelOpen(false)}
        onResponsavelChange={handleEditarLotacaoResponsavel}
        isCadastroImovel={isCadastroImovel}
        isCadastroIndividual={isCadastroIndividual}
        isAtividadeColetiva={isAtividadeColetiva}
        loadItemsOnOpen={loadItemsOnOpen}
        title={modalTitle}
        lotacaoLabel={modalLotacaoLabel}
        canWriteCadastroIndividual={canWriteCadastroIndividual}
        disableProfissionalFilters={shouldDisableProfissionalFilters}
        apenasAps={apenasAps}
      />
    </Fragment>
  )
}

const getLotacaoErrorMessage = (
  lotacao: LotacaoAndEstagioSelectFieldModel,
  isCadastroImovel: boolean,
  isCadastroIndividual: boolean,
  skipCboValidation: boolean
) => {
  if (isUndefinedOrNull(lotacao.profissional)) {
    return MENSAGEM_RESPONSAVEL_NAO_INFORMADO
  }

  if (isUndefinedOrNull(lotacao.cbo)) {
    return MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_SEM_CBO
  }

  if (isCadastroImovel && !lotacao.cbo.actions?.cadastroDomiciliar?.enabled) {
    return MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_CBO_SEM_PERMISSAO_IMOVEL
  }

  if (skipCboValidation) {
    return
  }

  if ((isCadastroImovel || isCadastroIndividual) && !lotacao.cbo.actions?.cadastroIndividual.enabled) {
    return MENSAGEM_RESPONSAVEL_ACOMPANHAMENTO_CBO_SEM_PERMISSAO_CIDADAO
  }
}
